'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const IssueActiveText = styled(Box)(({theme}) => ({
    whiteSpace: 'nowrap',
    fontWeight: '700',
    fontSize: '1rem',
    color: theme.palette.text.primary,
    'span' : {
        fontSize: '.8rem',
        fontWeight: '700',
    },
    ' .green' : {
        color: theme.palette.success.main,
        marginRight: '.2rem'
    }
}));

export default IssueActiveText;
